import { classifyError } from './errorClassifier';
import { logErrorToAuditLogs, logErrorToConsole } from './errorLogger';
import { ClassifiedError } from './errorTypes';

export const handleServiceError = async (
  error: unknown,
  context?: {
    action?: string;
    table_name?: string;
    record_id?: string;
    component?: string;
  }
): Promise<ClassifiedError> => {
  const classifiedError = classifyError(error);
  
  // Log to console
  logErrorToConsole(classifiedError, context?.component || context?.action);
  
  // Log to audit logs asynchronously (don't await to avoid blocking)
  logErrorToAuditLogs(classifiedError, context).catch(console.error);
  
  return classifiedError;
};

export const throwClassifiedError = async (
  error: unknown,
  context?: {
    action?: string;
    table_name?: string;
    record_id?: string;
    component?: string;
  }
): Promise<never> => {
  const classifiedError = await handleServiceError(error, context);
  throw new Error(classifiedError.userMessage);
};
